import { render } from "./FishBookFilter.vue?vue&type=template&id=2c05c7dc&scoped=true&ts=true"
import script from "./FishBookFilter.vue?vue&type=script&lang=ts"
export * from "./FishBookFilter.vue?vue&type=script&lang=ts"

import "./FishBookFilter.vue?vue&type=style&index=0&id=2c05c7dc&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c05c7dc"]])

export default __exports__